<!-- 命令 -->

<template>
  <el-form label-width="100px" label-position="right" label-suffix="：">
    <el-form-item :label="$t('public.command')">
      <span class="cmd-text">{{ baseContent.cmd }}</span>
    </el-form-item>

    <!-- 列表 -->
    <div class="list">
      <div class="listPage" v-for="item in configList" :key="item.id">
        <span>{{ $timetransition(item['logTime']) }}</span>
        <!-- 只能输网络参数 -->
        <span>{{ $t('integration.network_parameters') }}</span>
        <span>{{ configFn(item['stepCode']) }}</span>
        <el-button
          type="text"
          size="small"
          :title="$t('public.details')"
          icon="el-icon-tickets"
          @click="configDetailFn(item)"
        ></el-button>
      </div>
    </div>
    <!-- 命令详情 -->
    <CmdDialog
      :title="title"
      :isShow.sync="isShow"
      v-bind="$attrs"
      :cmdObj="cmdObj"
    />
  </el-form>
</template>

<script>
import CmdDialog from './CmdDialog.vue'
import { getConfigLogContent } from '@/api/modules/deviceUrl.js'
import { configStep } from '@/utils/convert'

export default {
  props: ['rowData', 'cmd', 'configList', 'mode'],
  components: {
    CmdDialog
  },

  data () {
    return {
      loading: false,
      isShow: false,
      title: '',
      cmdObj: {}
    }
  },
  computed: {
    baseContent () {
      return {
        cmd: this.cmd
      }
    },
    isClickConfig () {
      return this.mode === 'view'
    }
  },
  methods: {
    // configISFn() {
    //     this.isClickConfig = !this.isClickConfig;
    // },
    clearValidate () {
      // if (this.$refs.form) {
      //     this.$refs.form.clearValidate();
      // }
    },
    // cancelFn() {
    //     this.isClickConfig = true;
    //     this.clearValidate();
    // },
    // async configSave() {
    //     let flag = await this.justify();
    //     if (!flag) return;
    //     this.loading = true;
    //     const { extPanId, channelPage, channelMask } = this.dioForm;
    //     let query = {
    //         extPanId: extPanId,
    //         channelPage: channelPage,
    //         channelMask: channelMask,
    //         idList: [this.rowData.id]
    //     };
    //     gatewayUpdateNetConfig(query)
    //         .then(({ result, state }) => {
    //             if (result && state.code === 200) {
    //                 this.$message.success($t('integration.update_successful'));
    //                 // this.httpUrlFn();
    //                 this.isClickConfig = !this.isClickConfig;
    //             } else {
    //                 this.$message.error(state.msg);
    //             }
    //         })
    //         .finally(() => {
    //             this.loading = false;
    //         });
    // },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    configDetailFn (row) {
      this.title = `[${
        row.deviceName
      }][${$t('integration.network_parameters')}] ${$t('integration.configuration_details')}-[${this.$timetransition(row.logTime)}]`

      getConfigLogContent({ configLogId: row.id }, 'gateway').then(
        ({ result }) => {
          if (result.content) {
            const JsonContent = JSON.parse(JSON.parse(result.content).content)
            let url = this.rowData.scopeName
            if (this.rowData.sceneName) {
              url += '/' + this.rowData.sceneName
            }
            if (this.rowData.carrierName) {
              url += '/' + this.rowData.carrierName
            }
            this.cmdObj = {
              url: url,
              name: this.rowData.name,
              mac: this.rowData.mac,
              config_status: this.rowData.configStatus,
              // carrierName: this.rowData['carrierName'],
              type: this.rowData.type,

              step: result.stepCode,
              cmd: JsonContent.cmd,
              ...JsonContent.item
            }
          }
          console.log(result)
          this.isShow = true
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.cmd-text {
  word-break: break-all;
  font-family: Consolas, Monaco, monospace;
  color: #303133;
}

.list {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.listPage {
  height: 40px;
  width: 100%;
  margin-top: 15px;
  padding: 0 15px;
  box-sizing: border-box;
  border-radius: 2px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
